export default __webpack_public_path__ + "static/two-d1651266feee353ae16c7f4bd42fbc10.png";